import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const tomos = [{
  emoji: '📘',
  title: 'Tomo I – Por Qué No Estás Vendiendo',
  subtitle: 'El diagnóstico completo detrás del contenido que no convierte.',
  description: 'Descubrí por qué tus publicaciones no están generando ventas, aunque se vean profesionales.',
  items: ['La mentira del contenido viral', 'Por qué las vistas no significan ventas', 'Errores invisibles que destruyen conversiones', 'Contenido que entretiene vs contenido que vende', 'El problema de publicar sin intención', 'Cómo piensa realmente un comprador', 'Psicología básica de conversión', 'Diagnóstico completo de contenido que no vende']
}, {
  emoji: '📗',
  title: 'Tomo II – Contenido Que Convierte',
  subtitle: 'El sistema práctico para transformar publicaciones en clientes.',
  description: 'Aprendé a crear contenido con intención de venta usando estructuras simples, hooks, CTAs y fórmulas listas para aplicar.',
  items: ['Cómo captar atención en segundos', 'Hooks que generan deseo', 'Publicaciones persuasivas', 'Fórmulas de contenido que venden', 'Storytelling aplicado a ventas', 'CTAs que hacen actuar', 'Reels que convierten', 'Estructuras para anuncios efectivos']
}, {
  emoji: '📕',
  title: 'Tomo III – Ventas con IA',
  subtitle: 'Cómo usar inteligencia artificial para crear contenido, anuncios y ventas más rápido.',
  description: 'Usá IA para ahorrar tiempo, crear mejores ideas y generar contenido más estratégico sin empezar desde cero.',
  items: ['Prompts para crear contenido', 'Prompts para anuncios', 'Prompts para hooks', 'Prompts para reels', 'Prompts para CTAs', 'Prompts para storytelling', 'Sistemas de automatización de contenido', 'Flujo de trabajo con IA para marketing']
}];
export const Features = () => {
  return <section className="py-12 md:py-24 bg-brand-dark" data-id="element-48">
      <div className="container px-4 mx-auto max-w-6xl" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-10 md:mb-16 text-center" data-id="element-50">
          <h2 className="mb-4 md:mb-6 text-3xl font-bold md:text-5xl" data-id="element-51">
            ¿Qué incluye{' '}
            <span className="text-gradient-gold" data-id="element-52">Marketing PRO</span>?
          </h2>
          <p className="max-w-2xl mx-auto text-base md:text-xl text-gray-400" data-id="element-53">
            Un sistema completo de recursos listos para usar. Incluye 3 tomos
            principales con estrategias, plantillas, prompts y herramientas
            prácticas.
          </p>
        </motion.div>

        <div className="grid gap-6 md:gap-8 md:grid-cols-3" data-id="element-54">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="flex flex-col p-6 md:p-8 border bg-brand-card rounded-2xl border-white/5 hover:border-brand-gold/30 transition-colors relative overflow-hidden group" data-id="element-55">
              <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/5 rounded-bl-full -z-10 group-hover:bg-brand-gold/10 transition-colors" data-id="element-56" />

              <div className="mb-4 md:mb-6 text-5xl" data-id="element-57">{tomo.emoji}</div>
              <h3 className="mb-3 text-xl md:text-2xl font-bold text-white font-serif" data-id="element-58">
                {tomo.title}
              </h3>
              <p className="mb-3 md:mb-4 font-medium text-brand-gold-light" data-id="element-59">
                {tomo.subtitle}
              </p>
              <p className="mb-6 md:mb-8 text-gray-400" data-id="element-60">{tomo.description}</p>

              <div className="mt-auto" data-id="element-61">
                <div className="mb-4 text-sm font-semibold tracking-wider text-gray-500 uppercase" data-id="element-62">
                  Incluye:
                </div>
                <ul className="space-y-3" data-id="element-63">
                  {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-64">
                      <Check className="w-5 h-5 shrink-0 text-brand-gold" data-id="element-65" />
                      <span data-id="element-66">{item}</span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};